import { z } from 'zod';

export const contentFormatCodeSchema = z.enum(['reels', 'warming', 'carousel', 'lead_magnet']);
export type ContentFormatCode = z.infer<typeof contentFormatCodeSchema>;

export const contentFormatSchema = z.object({
  id: z.number().int().positive(),
  code: contentFormatCodeSchema,
  name: z.string(),
  description: z.string().nullable(),
  isActive: z.boolean(),
  sortOrder: z.number().int(),
});

export type ContentFormat = z.infer<typeof contentFormatSchema>;

/** Public wire DTO for GET /formats (snake_case). */
export const contentFormatDtoSchema = z.object({
  code: contentFormatCodeSchema,
  name: z.string(),
  description: z.string().nullable(),
  sort_order: z.number().int(),
});
export type ContentFormatDto = z.infer<typeof contentFormatDtoSchema>;

export const formatsListResponseSchema = z.object({
  formats: z.array(contentFormatDtoSchema),
});
export type FormatsListResponse = z.infer<typeof formatsListResponseSchema>;
